import React, { useState, useContext, useEffect } from "react";
import clsx from "clsx";
import {
  makeStyles,
  Drawer,
  List,
  ListItem,
  Typography,
  Divider,
  MenuItem,
  IconButton,
  Menu,
  useTheme,
  useMediaQuery,
  Slider,
  Grid,
  Avatar,
  Box,
  AppBar,
  Toolbar,
  Tooltip,
  ListSubheader,
  Switch,
  FormControlLabel,
} from "@material-ui/core";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";

import MainListItems from "./MainListItems";
import AccordionMenu from "../components/AccordionMenu";
import NotificationsPopOver from "../components/NotificationsPopOver";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import useAuth from "../hooks/useAuth.js";
import BackdropLoading from "../components/BackdropLoading";
import toastError from "../errors/toastError";
import PhoneVerificationGate from "../components/PhoneVerificationGate";

//import logo from "../assets/logo.png";
import { SocketContext } from "../context/Socket/SocketContext";

import { useWebInfo } from "../context/WebInfoContext";

import ColorModeContext from "../layout/themeContext";
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import VolumeDownIcon from '@material-ui/icons/VolumeDown';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import LoggerConfig from "../components/LoggerConfig";
import SettingsIcon from '@material-ui/icons/Settings';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LanguageIcon from '@material-ui/icons/Language';
import PaletteIcon from '@material-ui/icons/Palette';
import { getProfilePicUrl } from "../services/api";
import { getInitials } from "../helpers/getInitials";
import { generateColor } from "../helpers/colorGenerator";
import AnnouncementsOnLogin from "../components/AnnouncementsOnLogin";
import UpdateVersionModal from "../components/UpdateVersionModal";
import ChatPopover from "../pages/Chat/ChatPopover";
import WhatsAppConnectionsMenu from "../components/WhatsAppConnectionsMenu";
import AnnouncementsPopover from "../components/AnnouncementsPopover";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import GetAppIcon from "@material-ui/icons/GetApp";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import { useHistory, useLocation } from "react-router-dom";
import api from "../services/api";
import { i18n } from "../translate/i18n";
import { isCompanyAdmin, profileI18nKey } from "../helpers/userAccess";
import { applyPanelLanguage } from "../translate/uiLanguage";
import usePwaInstall from "../hooks/usePwaInstall";
import PwaInstallBanner, {
  IosInstallDialog,
  enableAppNotifications,
  notificationPermission,
} from "../components/PwaInstallBanner";
import MobileBottomNav, { hideMobileBar } from "../components/MobileBottomNav";

const drawerWidth = 280; // ✅ AUMENTADO PARA MÁS ESPACIO EN SUB-MENÚS

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    height: "100dvh",
    maxHeight: "100vh",
    maxHeight: "100dvh",
    overflow: "hidden", // ✅ Evitar scroll en el root
    backgroundColor: theme.palette.fancyBackground,
    '& .MuiButton-outlinedPrimary': {
      color: theme.palette.primary.main,
      backgroundColor: "transparent",
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: theme.palette.primary.main,
    }
  },
  avatar: {
    width: "100%",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    color: theme.palette.dark.main,
    background: theme.palette.barraSuperior,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 8px",
    minHeight: "48px",
    [theme.breakpoints.down("sm")]: {
      height: "48px"
    },
    '& img': {
      transition: 'opacity 0.3s ease',
    },
    '&.collapsed img': {
      opacity: 0,
      width: 0,
      height: 0,
      overflow: 'hidden',
    },
    '&.collapsed': {
      justifyContent: "center",
    }
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarFixed: {
    position: "fixed",
    top: 0,
    right: 0,
    left: 0,
    width: "100%",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.barraSuperior,
    color: "#fff",
    borderBottom: "none",
    boxShadow: "0 1px 0 rgba(15, 23, 42, 0.08)",
    overflow: "hidden",
    paddingTop: "env(safe-area-inset-top, 0px)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarFixedClosed: {},
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  toolbarFixed: {
    minHeight: "56px",
    maxHeight: "56px",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
    backgroundColor: "transparent",
    overflow: "hidden",
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      minHeight: 52,
      maxHeight: 52,
    },
    '& .MuiIconButton-root': {
      color: '#fff !important',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.12)',
      }
    },
    '& .MuiSvgIcon-root': {
      color: 'inherit',
    }
  },
  menuButton: {
    marginRight: 8,
    color: "#fff",
  },
  menuButtonHidden: {
    display: "none",
  },
  mobileMenuButton: {
    marginRight: theme.spacing(1),
    color: "#fff",
  },
  appBarBrand: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
    flexShrink: 0,
  },
  appBarLogoImg: {
    display: "block",
    height: 28,
    maxWidth: 160,
    width: "auto",
    objectFit: "contain",
    filter: "brightness(0) invert(1)",
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    color: "white",
  },
  drawerDock: {
    width: drawerWidth,
    flexShrink: 0,
    margin: "8px 0 8px 8px",
    marginTop: 64,
    height: "calc(100vh - 72px)",
    border: "none",
    backgroundColor: "transparent",
    overflow: "visible",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: 0,
      marginTop: 0,
      height: "100%",
    },
  },
  drawerDockClose: {
    width: 72,
    [theme.breakpoints.up("sm")]: {
      width: 72,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  drawerPaper: {
    position: "relative !important",
    whiteSpace: "nowrap",
    width: "100% !important",
    height: "100% !important",
    margin: "0 !important",
    top: "auto !important",
    left: "auto !important",
    backgroundColor: theme.mode === 'dark' ? '#111827' : '#ffffff',
    border: "none",
    borderRadius: 16,
    boxShadow: theme.mode === 'dark'
      ? "0 8px 28px rgba(0,0,0,0.45)"
      : "0 8px 28px rgba(15,23,42,0.10)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      position: "fixed !important",
      width: "min(86vw, 340px) !important",
      height: "100% !important",
      maxHeight: "100dvh",
      borderRadius: "0 16px 16px 0",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 1px rgba(255,255,255,0.06), 0 24px 48px rgba(0,0,0,0.55)"
        : "0 24px 48px rgba(15,23,42,0.28)",
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    },
    ...theme.scrollbarStylesSoft
  },
  drawerPaperClose: {
    overflowX: "hidden",
  },
  appBarSpacer: {
    minHeight: "48px",
  },
  content: {
    flex: 1,
    height: "calc(100vh - 56px)", // ✅ Altura exacta menos la AppBar
    maxHeight: "calc(100vh - 56px)", // ✅ Evitar overflow
    overflowY: "auto", // ✅ Solo scroll vertical cuando sea necesario
    overflowX: "hidden", // ✅ Sin scroll horizontal
    display: "flex",
    flexDirection: "column",
    marginTop: "calc(56px + env(safe-area-inset-top, 0px))",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100dvh - 52px - env(safe-area-inset-top, 0px))",
      maxHeight: "calc(100dvh - 52px - env(safe-area-inset-top, 0px))",
      marginTop: "calc(52px + env(safe-area-inset-top, 0px))",
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    },
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeInOut, // ✅ TRANSICIÓN SUAVE
      duration: theme.transitions.duration.standard, // ✅ DURACIÓN ESTÁNDAR
    }),
    // ✅ Ocultar scrollbar cuando no hay contenido que hacer scroll
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.mode === 'dark' ? '#4B5563' : '#cbd5e0',
      borderRadius: '4px',
      '&:hover': {
        background: theme.mode === 'dark' ? '#6B7280' : '#a0aec0',
      }
    },
  },
  contentMobileBar: {
    [theme.breakpoints.down("sm")]: {
      height: "calc(100dvh - 52px - 84px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))",
      maxHeight: "calc(100dvh - 52px - 84px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))",
    },
  },
  contentTickets: {
    overflow: "hidden",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column"
  },
  containerWithScroll: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    ...theme.scrollbarStyles,
    '& .MuiListItemIcon-root': {
      minWidth: '40px',
      justifyContent: 'center',
      '& svg': {
        fontSize: '20px',
      },
    },
  },
  containerWithScrollCollapsed: {
    padding: "8px 6px",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
    },
    scrollbarWidth: "none",
    '& .MuiListItemIcon-root': {
      minWidth: "auto",
      marginRight: 0,
      width: 28,
      justifyContent: 'center',
    },
  },
  NotificationsPopOver: {
    // color: theme.barraSuperior.secondary.main,
  },
  logo: {
    width: "80%",
    height: "auto",
    maxWidth: 180,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      height: "80%",
      maxWidth: 180,
    },
    logo: theme.logo
  },
  /** Logo del drawer: en móvil no debe desbordar la barra superior del menú */
  drawerLogoImg: {
    margin: "0 auto",
    display: "block",
    width: "50%",
    maxWidth: 180,
    maxHeight: 52,
    height: "auto",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      maxWidth: "72%",
      maxHeight: 40,
    },
  },
  planBadge: {
    height: 32,
    maxWidth: 240,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    padding: theme.spacing(0, 1.25),
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.28)",
    backgroundColor: "rgba(255,255,255,0.16)",
    color: "#fff",
    flexShrink: 1,
    minWidth: 0,
    [theme.breakpoints.down("md")]: {
      maxWidth: 160,
    },
    [theme.breakpoints.down("sm")]: {
      width: 18,
      minWidth: 18,
      maxWidth: 18,
      height: 18,
      padding: 0,
      gap: 0,
      justifyContent: "center",
      border: "none",
      backgroundColor: "transparent",
    },
  },
  planStatusDot: {
    width: 9,
    height: 9,
    borderRadius: "50%",
    flexShrink: 0,
    boxShadow: "0 0 0 2px rgba(255,255,255,0.35)",
  },
  planBadgeText: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1,
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  appBarActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    minWidth: 0,
    flexShrink: 1,
  },
  appBarUserName: {
    display: "none",
  },
  drawerUserCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    margin: "8px 10px 12px",
    padding: "8px 10px",
    borderRadius: 14,
    cursor: "pointer",
    backgroundColor: theme.mode === "dark" ? "#1f2937" : "#f8f9fc",
    minWidth: 0,
    flexShrink: 0,
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "#253044" : "#eef1f8",
    },
  },
  drawerUserChevron: {
    color: theme.mode === "dark" ? "#9ca3af" : "#94a3b8",
    fontSize: 20,
    flexShrink: 0,
  },
  profileMenuPaper: {
    borderRadius: 14,
    minWidth: 280,
    overflow: "hidden",
    boxShadow:
      theme.mode === "dark"
        ? "0 12px 32px rgba(0,0,0,0.5)"
        : "0 12px 32px rgba(15,23,42,0.16)",
    border: `1px solid ${theme.mode === "dark" ? "#374151" : "#e5e8f0"}`,
  },
  profileMenuHeader: {
    padding: "14px 16px 10px",
    backgroundColor: theme.mode === "dark" ? "#111827" : "#fff",
  },
  profileMenuName: {
    fontSize: 15,
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  profileMenuEmail: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  drawerUserMeta: {
    minWidth: 0,
    flex: 1,
  },
  drawerUserName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.mode === "dark" ? "#f9fafb" : "#111827",
    lineHeight: 1.2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  drawerUserStatus: {
    fontSize: 11,
    color: theme.mode === "dark" ? "#9ca3af" : "#6b7280",
    lineHeight: 1.3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  drawerUserAvatarWrap: {
    position: "relative",
    width: 36,
    height: 36,
    flexShrink: 0,
  },
  "@keyframes trafficPulse": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(34, 197, 94, 0.55)",
    },
    "70%": {
      boxShadow: "0 0 0 8px rgba(34, 197, 94, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(34, 197, 94, 0)",
    },
  },
  "@keyframes trafficPulseOff": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(239, 68, 68, 0.45)",
    },
    "70%": {
      boxShadow: "0 0 0 8px rgba(239, 68, 68, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(239, 68, 68, 0)",
    },
  },
  "@keyframes trafficPulseWait": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(245, 158, 11, 0.5)",
    },
    "70%": {
      boxShadow: "0 0 0 8px rgba(245, 158, 11, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(245, 158, 11, 0)",
    },
  },
  presenceDot: {
    position: "absolute",
    right: -1,
    bottom: -1,
    width: 11,
    height: 11,
    borderRadius: "50%",
    border: `2px solid ${theme.mode === "dark" ? "#1f2937" : "#ffffff"}`,
    boxSizing: "border-box",
    zIndex: 1,
  },
  presenceOnline: {
    backgroundColor: "#22c55e",
    animation: "$trafficPulse 1.6s ease-out infinite",
  },
  presenceConnecting: {
    backgroundColor: "#f59e0b",
    animation: "$trafficPulseWait 1s ease-out infinite",
  },
  presenceOffline: {
    backgroundColor: "#ef4444",
    animation: "$trafficPulseOff 2.2s ease-out infinite",
  },
  presenceLabelDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
}));

const getDaysLeft = (dueDate) => {
  if (!dueDate) return null;
  const due = new Date(dueDate);
  if (Number.isNaN(due.getTime())) return null;

  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const dueStart = new Date(due.getFullYear(), due.getMonth(), due.getDate());
  return Math.ceil((dueStart.getTime() - todayStart.getTime()) / 86400000);
};

const getPlanStatusColor = (daysLeft, theme) => {
  if (daysLeft === null) return theme.palette.text.secondary;
  if (daysLeft < 0) return theme.palette.error.main;
  if (daysLeft === 0) return theme.palette.error.main;
  if (daysLeft <= 7) return "#f59e0b";
  return "#059669";
};

const getPlanStatusLabel = (daysLeft) => {
  if (daysLeft === null) return "Sin fecha de vencimiento";
  if (daysLeft <= 0) return "Vencido";
  if (daysLeft <= 7) return "Por vencer";
  return "Vigente";
};

const formatPlanDays = (daysLeft) => {
  if (daysLeft === null) return "sin vencimiento";
  if (daysLeft < 0) return `vencido hace ${Math.abs(daysLeft)} d`;
  if (daysLeft === 0) return "vence hoy";
  if (daysLeft === 1) return "1 día";
  return `${daysLeft} días`;
};

const LoggedInLayout = ({ children, themeToggle }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [userModalOpen, setUserModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [langMenuAnchorEl, setLangMenuAnchorEl] = useState(null);
  const [loggerConfigOpen, setLoggerConfigOpen] = useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [updateVersionModalOpen, setUpdateVersionModalOpen] = useState(false);
  const { loading, mergeSessionUser, user } = useContext(AuthContext);
  const { handleLogout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");
  const [companyPlan, setCompanyPlan] = useState(null);
  
  // ✅ CONFIGURACIÓN PARA ALTERNAR ENTRE MENÚS
  const [useNewMenu] = useState(true); // ✅ Nuevo menú por defecto
  // const [dueDate, setDueDate] = useState("");

  const changePanelLanguage = async (lng) => {
    handleCloseMenu();
    if (!user?.id) {
      applyPanelLanguage(lng);
      return;
    }
    const current = user.language || "es";
    if (current === lng) {
      applyPanelLanguage(lng);
      return;
    }
    try {
      const { data } = await api.put(`/users/${user.id}`, { language: lng });
      mergeSessionUser(data);
    } catch (err) {
      toastError(err);
    }
  };

  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);

  const [volume, setVolume] = useState(Number(localStorage.getItem("volume")) || 1);

  useEffect(() => {
    localStorage.setItem("volume", volume);
  }, [volume]);

  // FASE 6 — Wizard de onboarding solo al entrar en Agenda (/appointments).
  // No forzar /onboarding en el resto del sistema (Chats, Tickets, Configuración, etc.).
  useEffect(() => {
    if (location.pathname === "/onboarding") return;
    if (location.pathname !== "/appointments") return;
    api.get("/onboarding/config").then(({ data }) => {
      if (!data.business) history.replace("/onboarding");
    }).catch(() => {});
  }, [location.pathname, history]);

  const { loadWebInfo } = useWebInfo();

  useEffect(() => {
    const companyId = user?.companyId || localStorage.getItem("companyId");
    if (!companyId) {
      setCompanyPlan(null);
      return;
    }

    let active = true;
    api.get(`/companies/listPlan/${companyId}`)
      .then(({ data }) => {
        if (active) {
          setCompanyPlan(data);
        }
      })
      .catch(() => {
        if (active) {
          setCompanyPlan(null);
        }
      });

    return () => {
      active = false;
    };
  }, [user?.companyId]);

  //################### CODIGOS DE TESTE #########################################
  // useEffect(() => {
  //   navigator.getBattery().then((battery) => {
  //     console.log(`Battery Charging: ${battery.charging}`);
  //     console.log(`Battery Level: ${battery.level * 100}%`);
  //     console.log(`Charging Time: ${battery.chargingTime}`);
  //     console.log(`Discharging Time: ${battery.dischargingTime}`);
  //   })
  // }, []);

  // useEffect(() => {
  //   const geoLocation = navigator.geolocation

  //   geoLocation.getCurrentPosition((position) => {
  //     let lat = position.coords.latitude;
  //     let long = position.coords.longitude;

  //     console.log('latitude: ', lat)
  //     console.log('longitude: ', long)
  //   })
  // }, []);

  // useEffect(() => {
  //   const nucleos = window.navigator.hardwareConcurrency;

  //   console.log('Nucleos: ', nucleos)
  // }, []);

  // useEffect(() => {
  //   console.log('userAgent', navigator.userAgent)
  //   if (
  //     navigator.userAgent.match(/Android/i)
  //     || navigator.userAgent.match(/webOS/i)
  //     || navigator.userAgent.match(/iPhone/i)
  //     || navigator.userAgent.match(/iPad/i)
  //     || navigator.userAgent.match(/iPod/i)
  //     || navigator.userAgent.match(/BlackBerry/i)
  //     || navigator.userAgent.match(/Windows Phone/i)
  //   ) {
  //     console.log('é mobile ', true) //celular
  //   }
  //   else {
  //     console.log('não é mobile: ', false) //nao é celular
  //   }
  // }, []);
  //##############################################################################

  const socketManager = useContext(SocketContext);
  const [presence, setPresence] = useState("online");

  useEffect(() => {
    const companyId = user?.companyId || localStorage.getItem("companyId");
    if (!companyId) return undefined;
    const managed = socketManager.getSocket(companyId);
    const raw = managed?.socket || managed;
    if (!raw || typeof raw.on !== "function") return undefined;

    const sync = () => {
      if (raw.connected) setPresence("online");
      else setPresence("offline");
    };
    const onConnect = () => setPresence("online");
    const onDisconnect = () => setPresence("offline");
    const onReconnectAttempt = () => setPresence("connecting");

    sync();
    raw.on("connect", onConnect);
    raw.on("disconnect", onDisconnect);
    raw.on("reconnect_attempt", onReconnectAttempt);
    if (raw.io && typeof raw.io.on === "function") {
      raw.io.on("reconnect_attempt", onReconnectAttempt);
    }

    return () => {
      raw.off("connect", onConnect);
      raw.off("disconnect", onDisconnect);
      raw.off("reconnect_attempt", onReconnectAttempt);
      if (raw.io && typeof raw.io.off === "function") {
        raw.io.off("reconnect_attempt", onReconnectAttempt);
      }
    };
  }, [socketManager, user?.companyId]);

  // ✅ NUEVO: Escuchar cambios en las configuraciones del sitio web
  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    const handleSettingsUpdate = (data) => {
      if (data.action === "update") {
        // Si se actualiza alguna configuración del sitio web, recargar la información
        if (['websiteTitle', 'websiteDescription', 'websiteKeyword'].includes(data.setting.key)) {
          loadWebInfo();
        }
      }
    };

    // ✅ LIMPIAR LISTENER ANTERIOR PARA EVITAR DUPLICADOS
    socket.off(`company-${companyId}-settings`, handleSettingsUpdate);
    socket.on(`company-${companyId}-settings`, handleSettingsUpdate);

    return () => {
      // ✅ SOLO REMOVER LISTENERS, NO DESCONECTAR EL SOCKET COMPARTIDO
      if (socket && typeof socket.off === 'function') {
        socket.off(`company-${companyId}-settings`, handleSettingsUpdate);
      }
    };
  }, [socketManager, loadWebInfo]);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { canInstall, promptInstall, isStandalone, isIos } = usePwaInstall();
  const [iosInstallOpen, setIosInstallOpen] = useState(false);
  const [pushPermission, setPushPermission] = useState(notificationPermission);

  useEffect(() => {
    const sync = () => setPushPermission(notificationPermission());
    window.addEventListener("watoolx-push-updated", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("watoolx-push-updated", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth > 1200) {
      setDrawerOpen(true);
    }
  }, []);

  useEffect(() => {
    setDrawerVariant(isMobile ? "temporary" : "permanent");
  }, [isMobile]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const userId = localStorage.getItem("userId");
    let timeoutId = null;

    const socket = socketManager.getSocket(companyId);

    const handleAuthEvent = (data) => {
      if (data.user.id === +userId) {
        toastError("Sua conta foi acessada em outro computador.");
        timeoutId = setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 1000);
      }
    };

    // ✅ LIMPIAR LISTENER ANTERIOR PARA EVITAR DUPLICADOS
    socket.off(`company-${companyId}-auth`, handleAuthEvent);
    socket.on(`company-${companyId}-auth`, handleAuthEvent);

    socket.emit("userStatus");
    const interval = setInterval(() => {
      socket.emit("userStatus");
    }, 1000 * 60 * 5);

    return () => {
      // ✅ SOLO REMOVER LISTENERS, NO DESCONECTAR EL SOCKET COMPARTIDO
      if (socket && typeof socket.off === 'function') {
        socket.off(`company-${companyId}-auth`, handleAuthEvent);
        socket.off(`company-${companyId}-notification`);
        socket.off("ready");
        socket.off("connect");
        socket.off("disconnect");
      }
      // ✅ LIMPIAR INTERVAL Y TIMEOUT PARA EVITAR MEMORY LEAKS
      if (interval) {
        clearInterval(interval);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [socketManager]);

  // eslint-disable-next-line no-unused-vars
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
    setLangMenuAnchorEl(null);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleLogoutClick = () => {
    handleLogout();
    handleCloseMenu();
  };

  const handleInstallApp = async () => {
    handleCloseMenu();
    if (canInstall) {
      const choice = await promptInstall();
      if (choice?.outcome === "accepted") {
        await enableAppNotifications();
        setPushPermission(notificationPermission());
      }
      return;
    }
    if (isIos && !isStandalone) {
      setIosInstallOpen(true);
    }
  };

  const handleEnableNotifications = async () => {
    handleCloseMenu();
    await enableAppNotifications();
    setPushPermission(notificationPermission());
  };

  const handleSettingsMenu = (event) => {
    setSettingsAnchorEl(event.currentTarget);
    setSettingsMenuOpen(true);
  };

  const handleCloseSettingsMenu = () => {
    setSettingsAnchorEl(null);
    setSettingsMenuOpen(false);
  };



  /** Cierre diferido en móvil para que RouterLink termine history.push antes de desmontar el menú */
  const drawerClose = () => {
    if (isMobile) {
      setTimeout(() => setDrawerOpen(false), 80);
    }
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const toggleColorMode = () => {
    colorMode.toggleColorMode();
  }

  const planDaysLeft = getDaysLeft(companyPlan?.dueDate);
  const planExpired = Boolean(user?.id) && !user?.super && planDaysLeft != null && planDaysLeft < 0;

  useEffect(() => {
    if (!planExpired) return;
    if (location.pathname === "/financeiro") return;
    history.replace("/financeiro");
  }, [planExpired, location.pathname, history]);

  if (loading) {
    return <BackdropLoading />;
  }
  
  // ✅ SOLUCIONADO: Logo sin Math.random() para evitar bucle infinito
  const logo = `${process.env.REACT_APP_BACKEND_URL || window.location.origin}/public/logotipos/interno.png`;
  const planName = companyPlan?.plan?.name || "Sin plan";
  const daysLeft = getDaysLeft(companyPlan?.dueDate);
  const planDaysText = formatPlanDays(daysLeft);
  const planColor = getPlanStatusColor(daysLeft, theme);
  const planStatusLabel = getPlanStatusLabel(daysLeft);
  const planDueDateText = companyPlan?.dueDate
    ? new Date(companyPlan.dueDate).toLocaleDateString()
    : "Sin fecha de vencimiento";

  return (
    <div className={classes.root}>
      <Drawer
        variant={drawerVariant}
        className={clsx(classes.drawerDock, !drawerOpen && classes.drawerDockClose)}
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose
          ),
        }}
        open={drawerOpen}
        onClose={drawerVariant === "temporary" ? handleDrawerClose : undefined}
      >
        <List className={clsx(classes.containerWithScroll, !drawerOpen && classes.containerWithScrollCollapsed)}>
          {planExpired ? (
            <Box style={{ padding: 16 }}>
              <Typography style={{ fontWeight: 700, marginBottom: 8 }}>
                {i18n.t("backendErrors.ERR_COMPANY_EXPIRED")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {i18n.t("backendErrors.COMPANY_EXPIRED_MENU")}
              </Typography>
            </Box>
          ) : useNewMenu ? (
            <AccordionMenu drawerClose={drawerClose} drawerOpen={drawerOpen} />
          ) : (
            <MainListItems drawerClose={drawerClose} collapsed={!drawerOpen} />
          )}
        </List>
        <Divider />
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={menuOpen}
          onClose={handleCloseMenu}
          PaperProps={{ className: classes.profileMenuPaper }}
        >
          <Box className={classes.profileMenuHeader}>
            <Typography className={classes.profileMenuName}>{user?.name || "Admin"}</Typography>
            <Typography className={classes.profileMenuEmail}>
              {user?.email || ""}
            </Typography>
          </Box>
          <Divider />
          <MenuItem disabled>
            <span
              className={clsx(
                classes.presenceLabelDot,
                presence === "offline"
                  ? classes.presenceOffline
                  : presence === "connecting"
                  ? classes.presenceConnecting
                  : classes.presenceOnline
              )}
              style={{ marginRight: 10, animation: "none" }}
            />
            {presence === "offline"
              ? "Fuera de línea"
              : presence === "connecting"
              ? "Reconectando"
              : "En línea"}
          </MenuItem>
          <MenuItem onClick={handleOpenUserModal}>
            <PersonOutlineIcon style={{ marginRight: 10, fontSize: 20 }} />
            Perfil
          </MenuItem>
          <MenuItem onClick={handleOpenUserModal}>
            <MailOutlineIcon style={{ marginRight: 10, fontSize: 20 }} />
            Cambiar email
          </MenuItem>
          <MenuItem onClick={(e) => setLangMenuAnchorEl(e.currentTarget)}>
            <LanguageIcon style={{ marginRight: 10, fontSize: 20 }} />
            Idioma
            <ExpandMoreIcon style={{ marginLeft: "auto", transform: "rotate(-90deg)" }} />
          </MenuItem>
          <MenuItem
            onClick={() => {
              toggleColorMode();
            }}
          >
            <PaletteIcon style={{ marginRight: 10, fontSize: 20 }} />
            Tema de color
          </MenuItem>
          <MenuItem>
            {theme.mode === "dark" ? (
              <Brightness7Icon style={{ marginRight: 10, fontSize: 20 }} />
            ) : (
              <Brightness4Icon style={{ marginRight: 10, fontSize: 20 }} />
            )}
            <FormControlLabel
              style={{ margin: 0, width: "100%", justifyContent: "space-between" }}
              label="Modo oscuro"
              labelPlacement="start"
              control={
                <Switch
                  size="small"
                  color="primary"
                  checked={theme.mode === "dark"}
                  onChange={() => toggleColorMode()}
                />
              }
            />
          </MenuItem>
          <MenuItem>
            <Grid container spacing={1} alignItems="center" style={{ width: "100%" }}>
              <Grid item>
                <VolumeDownIcon />
              </Grid>
              <Grid item xs>
                <Slider
                  value={volume}
                  onChange={(e, newValue) => setVolume(newValue)}
                  min={0}
                  max={1}
                  step={0.1}
                  style={{ color: theme.palette.primary.main }}
                />
              </Grid>
              <Grid item>
                <VolumeUpIcon />
              </Grid>
            </Grid>
          </MenuItem>
          {(!isStandalone && (canInstall || isIos)) && (
            <MenuItem onClick={handleInstallApp}>
              <GetAppIcon style={{ marginRight: 10, fontSize: 20 }} />
              {i18n.t("mainDrawer.appBar.pwa.installApp")}
            </MenuItem>
          )}
          {pushPermission !== "granted" && !(isIos && !isStandalone) && (
            <MenuItem onClick={handleEnableNotifications}>
              <NotificationsActiveIcon style={{ marginRight: 10, fontSize: 20 }} />
              {i18n.t("mainDrawer.appBar.pwa.enableNotifications")}
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              setLoggerConfigOpen(true);
            }}
          >
            <SettingsIcon style={{ marginRight: 10, fontSize: 20 }} />
            {i18n.t("mainDrawer.appBar.settingsMenu.logs")}
          </MenuItem>
          {user?.companyId === 1 && user?.super === true && (
            <MenuItem
              onClick={() => {
                handleCloseMenu();
                setUpdateVersionModalOpen(true);
              }}
            >
              <SystemUpdateAltIcon style={{ marginRight: 10, fontSize: 20 }} />
              {i18n.t("mainDrawer.appBar.tooltips.updateVersion")}
            </MenuItem>
          )}
          <Divider />
          <MenuItem onClick={handleLogoutClick} style={{ color: theme.palette.error.main }}>
            <ExitToAppIcon style={{ marginRight: 10, fontSize: 20, color: theme.palette.error.main }} />
            Cerrar sesión
          </MenuItem>
        </Menu>
        <Menu
          anchorEl={langMenuAnchorEl}
          open={Boolean(langMenuAnchorEl)}
          onClose={() => setLangMenuAnchorEl(null)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={() => changePanelLanguage("es")}>
            Español {(user?.language || "es") === "es" ? "✓" : ""}
          </MenuItem>
          <MenuItem onClick={() => changePanelLanguage("en")}>
            English {user?.language === "en" ? "✓" : ""}
          </MenuItem>
          <MenuItem onClick={() => changePanelLanguage("pt")}>
            Português {user?.language === "pt" ? "✓" : ""}
          </MenuItem>
        </Menu>
        <Box
          className={classes.drawerUserCard}
          onClick={handleOpenUserMenu}
          style={!drawerOpen ? { justifyContent: "center", padding: "8px 4px" } : undefined}
        >
          <Box className={classes.drawerUserAvatarWrap}>
            <Avatar
              src={
                user?.profilePicUrl &&
                !user.profilePicUrl.includes("nopicture.png")
                  ? getProfilePicUrl(user.profilePicUrl)
                  : null
              }
              style={{
                width: 36,
                height: 36,
                backgroundColor: generateColor(user?.name || ""),
                color: "#fff",
                fontWeight: "bold",
                fontSize: "13px",
              }}
            >
              {getInitials(user?.name || "")}
            </Avatar>
            <span
              className={clsx(
                classes.presenceDot,
                presence === "offline"
                  ? classes.presenceOffline
                  : presence === "connecting"
                  ? classes.presenceConnecting
                  : classes.presenceOnline
              )}
            />
          </Box>
          {drawerOpen && (
            <>
              <Box className={classes.drawerUserMeta}>
                <Typography className={classes.drawerUserName}>
                  {user?.name || "Admin"}
                </Typography>
                <Typography className={classes.drawerUserStatus}>
                  <span
                    className={clsx(
                      classes.presenceLabelDot,
                      presence === "offline"
                        ? classes.presenceOffline
                        : presence === "connecting"
                        ? classes.presenceConnecting
                        : classes.presenceOnline
                    )}
                  />
                  {i18n.t(profileI18nKey(user?.profile))} ·{" "}
                  {presence === "offline"
                    ? "Fuera de línea"
                    : presence === "connecting"
                    ? "Reconectando"
                    : "En línea"}
                </Typography>
              </Box>
              <ExpandMoreIcon
                className={classes.drawerUserChevron}
                style={{ transform: menuOpen ? "rotate(180deg)" : "none" }}
              />
            </>
          )}
        </Box>
      </Drawer>
      {/* ✅ BARRA SUPERIOR FIJA - Restaurada para mostrar notificaciones */}
      <AppBar 
        position="fixed" 
        className={clsx(classes.appBarFixed, !drawerOpen && classes.appBarFixedClosed)}
      >
        <Toolbar className={classes.toolbarFixed}>
          <Box className={classes.appBarBrand}>
            <Tooltip title={i18n.t("mainDrawer.appBar.tooltips.navigationMenu")} arrow>
              <IconButton
                edge="start"
                className={classes.mobileMenuButton}
                onClick={() => setDrawerOpen(!drawerOpen)}
                aria-label={i18n.t("mainDrawer.appBar.tooltips.openNavigationMenu")}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>
            <img
              src={logo}
              className={classes.appBarLogoImg}
              alt={`${(typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_NAME_SYSTEM : 'Sistema'}`}
            />
          </Box>
          <Box style={{ flex: 1 }} />
          <Box className={classes.appBarActions}>
            <Tooltip
              title={`${planStatusLabel}: plan ${planName}. Vencimiento: ${planDueDateText}. ${planDaysText}.`}
              arrow
            >
              <Box className={classes.planBadge}>
                <span className={classes.planStatusDot} style={{ backgroundColor: planColor }} />
                <Typography className={classes.planBadgeText}>
                  {planName} · {planDaysText}
                </Typography>
              </Box>
            </Tooltip>

            {isCompanyAdmin(user) && <WhatsAppConnectionsMenu />}

            {/* Ayuda */}
            <Tooltip title={i18n.t("mainDrawer.appBar.tooltips.help")} arrow>
              <IconButton
                className="hideOnMobile"
                onClick={() => history.push("/helps")}
                size="small"
                style={{
                  padding: '4px',
                  color: "#fff",
                  minWidth: '32px',
                  width: '32px',
                  height: '32px',
                }}
              >
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            {/* Chat Interno */}
            <Tooltip title={i18n.t("mainDrawer.appBar.tooltips.internalChat")} arrow>
              <span>
                <ChatPopover />
              </span>
            </Tooltip>
            
            {/* Anuncios */}
            <Tooltip title={i18n.t("mainDrawer.appBar.tooltips.announcements")} arrow>
              <span>
                <AnnouncementsPopover />
              </span>
            </Tooltip>
            
            {/* Notificaciones de WhatsApp */}
            <Tooltip title={i18n.t("mainDrawer.appBar.tooltips.whatsappNotifications")} arrow>
              <span>
                <NotificationsPopOver volume={volume} customStyle={{
                  padding: '4px',
                  color: "#fff",
                }} />
              </span>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      <UserModal
        open={userModalOpen}
        onClose={() => setUserModalOpen(false)}
        userId={user?.id}
      />
      <LoggerConfig
        open={loggerConfigOpen}
        onClose={() => setLoggerConfigOpen(false)}
      />
      <UpdateVersionModal
        open={updateVersionModalOpen}
        onClose={() => setUpdateVersionModalOpen(false)}
      />
      <main className={clsx(classes.content, location.pathname.startsWith("/tickets") && classes.contentTickets, isMobile && !hideMobileBar(location.pathname) && classes.contentMobileBar)}>
        {planExpired && (
          <Box style={{ margin: 16, padding: 16, borderRadius: 12, background: "#fff7ed", color: "#9a3412" }}>
            <Typography style={{ fontWeight: 700, marginBottom: 6 }}>
              {i18n.t("backendErrors.ERR_COMPANY_EXPIRED")}
            </Typography>
            <Typography variant="body2">
              {i18n.t("backendErrors.COMPANY_EXPIRED_BANNER")}
            </Typography>
          </Box>
        )}
        {user?.phoneVerified === false && !user?.super ? (
          <PhoneVerificationGate user={user} onVerified={() => mergeSessionUser({ phoneVerified: true })} />
        ) : (
          children || null
        )}
      </main>
      {!planExpired && <MobileBottomNav />}
      <AnnouncementsOnLogin />
      <PwaInstallBanner />
      <IosInstallDialog open={iosInstallOpen} onClose={() => setIosInstallOpen(false)} />
    </div>
  );
};

export default LoggedInLayout;
